
import {IKala} from "./kala.model";
import {IOrganization} from "./organization.model";
import {IStore} from "./store.model";

export interface IStock {
  id?: number;
  status?: string;
  title?: string;
  description?: string;
  count?: number;
  cost?: any;
  code?: any;
  discount?: any;
  order_point_count?: any;
  alarm_point_count?: any;
  alarm_point_date?: any;
  alarm_point_date_str?: string;
  cost_total?: any;
  kala?: any;
  store?: IStore;
  organization?: IOrganization;

}

export class Stock implements IStock {
  constructor(public id?: number,
              public count?: number,
              public cost?: any,
              public code?: any,
              public discount?: any,
              public cost_total?: any,
              public status?: string,
              public title?: string,
              public kala?: IKala,
              public description?: string) {
  }
}
